var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "300px", height: "0", overflow: "hidden" } },
    [
      _c(
        "div",
        {
          staticStyle: { width: "265px", "padding-left": "8px" },
          attrs: { id: "LodopPrintTemplate-info" }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "20px",
                "text-align": "center",
                "letter-spacing": "10px"
              }
            },
            [_vm._v("\n      一手退换货包裹\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { padding: "10px" } }),
          _vm._v(" "),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              [
                _c("qrcode-vue", {
                  key: _vm.info.package.package_no,
                  attrs: {
                    value: _vm.info.package.package_no,
                    size: 100,
                    level: "H",
                    "render-as": "svg"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "column",
                  "margin-left": "8px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "13px",
                      "line-height": "24px",
                      padding: "4px 0"
                    }
                  },
                  [
                    _vm._v(
                      "\n          市场: " +
                        _vm._s(_vm.info.package.parent_market_name) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "13px",
                      "line-height": "24px",
                      padding: "4px 0"
                    }
                  },
                  [
                    _vm._v(
                      "\n          子市场: " +
                        _vm._s(_vm.info.package.market_name) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "13px",
                      "line-height": "24px",
                      padding: "4px 0"
                    }
                  },
                  [
                    _vm._v(
                      "\n          代采组: " +
                        _vm._s(_vm.info.package.pg_name) +
                        "\n        "
                    )
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "13px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [
              _vm._v(
                "\n      包裹单号: " +
                  _vm._s(_vm.info.package.package_no) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "14px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [
              _vm._v("\n      商品数量："),
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(_vm._s(_vm.info.package.total))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "16px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [
              _vm._v(
                "\n      商家名称：" +
                  _vm._s(_vm.info.package.supply_name) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "16px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [
              _vm._v(
                "\n      换货专员：" +
                  _vm._s(_vm.info.package.dg_member_name) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "16px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [
              _vm._v("\n      商家收货地址：\n      "),
              _c("div", { staticStyle: { "font-size": "14px" } }, [
                _vm._v(_vm._s(_vm.info.package.address))
              ])
            ]
          ),
          _vm._v(" "),
          _c("img", {
            staticStyle: {
              display: "block",
              width: "240px",
              "text-align": "center",
              height: "100px",
              margin: "0 auto"
            },
            attrs: {
              src:
                "https://erp.yishouapp.com/barcode.php?text=" +
                _vm.info.package.package_no,
              alt: ""
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "16px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [
              _vm._v(
                "\n      分播方案：" +
                  _vm._s(_vm.info.case_name) +
                  " ，格口号：" +
                  _vm._s(_vm.info.grid_no) +
                  "\n    "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { padding: "130px" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: { width: "280px" },
          attrs: { id: "LodopPrintTemplate-list" }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "18px",
                "text-align": "left",
                "letter-spacing": "2px",
                "margin-bottom": "20px"
              }
            },
            [_vm._v("\n      退换货出库商品明细\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "13px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [
              _vm._v(
                "\n      包裹单号: " +
                  _vm._s(_vm.info.package.package_no) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "14px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [
              _vm._v("\n      商品数量："),
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(_vm._s(_vm.info.package.total))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "16px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [
              _vm._v(
                "\n      商家名称：" +
                  _vm._s(_vm.info.package.supply_name) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "14px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [
              _vm._v(
                "\n      校验打包时间： " +
                  _vm._s(_vm.info.package.pack_datetime) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "16px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [
              _vm._v(
                "\n      分播方案：" +
                  _vm._s(_vm.info.case_name) +
                  " ，格口号：" +
                  _vm._s(_vm.info.grid_no) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "14px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [_vm._v("\n      打包清单：\n    ")]
          ),
          _vm._v(" "),
          _c(
            "table",
            { staticStyle: { width: "100%", "border-collapse": "collapse" } },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.info.phd.detail, function(item, index) {
                  return _c("tr", { key: index }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "5px",
                          "text-align": "center",
                          border: "1px solid #ccc"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.goods_kh) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "5px",
                          "text-align": "center",
                          border: "1px solid #ccc"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.co_val) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "5px",
                          "text-align": "center",
                          border: "1px solid #ccc"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.si_val) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "5px",
                          "text-align": "center",
                          border: "1px solid #ccc"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.number) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                }),
                0
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { padding: "130px" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: { width: "265px", "padding-left": "8px" },
          attrs: { id: "LodopPrintTemplate-error" }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "16px",
                "line-height": "24px",
                padding: "6px 0"
              }
            },
            [
              _c("div", [
                _vm._v("分播方案：" + _vm._s(_vm.info.case_name) + " ")
              ]),
              _vm._v(" "),
              _c("div", [_vm._v("格口号：" + _vm._s(_vm.info.grid_no))])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "16px",
                "line-height": "24px",
                padding: "40px 0"
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.info.msg) + "\n    ")]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          {
            staticStyle: {
              padding: "5px",
              "text-align": "center",
              border: "1px solid #ccc"
            }
          },
          [_vm._v("\n            款号\n          ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              padding: "5px",
              "text-align": "center",
              border: "1px solid #ccc"
            }
          },
          [_vm._v("\n            颜色\n          ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              padding: "5px",
              "text-align": "center",
              border: "1px solid #ccc"
            }
          },
          [_vm._v("\n            尺码\n          ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              padding: "5px",
              "text-align": "center",
              border: "1px solid #ccc"
            }
          },
          [_vm._v("\n            数量\n          ")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d58af4bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d58af4bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/machine/components/LodopPrintTemplate.vue
// module id = null
// module chunks = 